import React from 'react';

interface ComingSoonProps {
  title: string;
}

const ComingSoon: React.FC<ComingSoonProps> = ({ title }) => {
  return (
    <div className="flex items-center justify-center h-full min-h-[calc(100vh-200px)]">
      <div className="text-center">
        <h1 className="text-5xl font-bold text-gray-800 mb-4">{title}</h1>
        <p className="text-2xl text-gray-600">Coming soon</p>
        <div className="mt-8">
          <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-gray-100">
            <svg 
              className="w-10 h-10 text-gray-400" 
              fill="none" 
              stroke="currentColor" 
              viewBox="0 0 24 24"
            >
              <path 
                strokeLinecap="round" 
                strokeLinejoin="round" 
                strokeWidth={2} 
                d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" 
              />
            </svg>
          </div>
        </div>
        <p className="mt-6 text-gray-500">
          We're working hard to bring you this feature.
        </p>
        <p className="text-gray-500">
          Please check back later.
        </p>
      </div>
    </div>
  );
};

export default ComingSoon;